import React from "react";
import LoadingCard from "./LoadingCard";
import CustomLine from "./customLine";

const LoadingWalletCard = ({ commonLoading, mapIndex = 5 }) => {
  return Array.from({ length: mapIndex }, (_, i) => i).map((item) => {
    return (
      <LoadingCard
        className={`!h-[65px] w-full !rounded-[5px] !mt-[0] !px-[20px] !py-[8px] flex items-center justify-between`}
        commonLoading={commonLoading}
      >
        <section className="flex flex-col items-start justify-between h-full">
          <CustomLine className={`w-[60px] h-[15px]`} />
          <CustomLine className={`w-[110px] h-[12px]`} />
        </section>
        <section className="flex items-center gap-[20px]">
          <CustomLine className={`w-[27.5px] h-[27.5px]`} circle />
          <CustomLine className={`w-[70px] h-[36px]`} />
        </section>
      </LoadingCard>
    );
  });
};

export default LoadingWalletCard;
